import React from "react";
import { useAuthContext } from "contexts";
import { Redirect } from "@reach/router";

export const PrivateRoute = ({ as: Component, ...props }) => {
  const { isLogined } = useAuthContext();
  return (
    <div>
      {isLogined || localStorage.getItem("user") ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" noThrow />
      )}
    </div>
  );
};
